export { default as stateToHTML } from './stateToHTML';


//////////////////
// WEBPACK FOOTER
// ../draft-js-export-html/esm/main.js
// module id = 2177
// module chunks = 25